import api from './api';

const shiftService = {
  uploadShift: async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/shifts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getShifts: async () => {
    const response = await api.get('/shifts');
    return response.data;
  },

  getShift: async (id) => {
    const response = await api.get(`/shifts/${id}`);
    return response.data;
  },

  deleteShift: async (id) => {
    const response = await api.delete(`/shifts/${id}`);
    return response.data;
  }
};

export default shiftService;
